/**
 * Um plano do catálogo da gestão (#765, fase 2, #766).
 *
 * ── O formato que a tela usa ──────────────────────────────────────────────
 *
 * A tela nasceu antes do back (decisão de 26/10/2026) com este formato, e o
 * contrato de `GET /v1/operacao/planos` traz os mesmos campos, com os nomes do
 * `/v1`. `planoDoCatalogo` só troca os nomes: nada é calculado no navegador.
 *
 * Os valores são o preço PADRÃO: no dia da contratação eles são copiados para
 * o contrato da organização, e mudar o plano depois não mexe em quem já tem.
 */

import type { Plano } from '@cliqcrm/contracts';

/** Dinheiro como o contrato manda: micros, para centavo não acumular erro. */
export type Dinheiro = { readonly quantia_micros: number; readonly moeda: string };

export type PlanoDoCatalogo = {
  readonly id: string;
  readonly nome: string;
  /** Inativo não aparece para organização nova; quem já tem continua com ele. */
  readonly ativo: boolean;
  /** Nula no plano legado, que a migração criou a partir do plano em texto. */
  readonly mensalidade: Dinheiro | null;
  /** Nulo no legado: cada organização ficou com os usuários que usava. */
  readonly usuariosIncluidos: number | null;
  readonly armazenamentoGb: number;
  /** O preço padrão de um usuário a mais; nulo enquanto não foi definido. */
  readonly usuarioAdicional: Dinheiro | null;
  /** O preço padrão de um GB a mais; nulo enquanto não foi definido. */
  readonly gbAdicional: Dinheiro | null;
  /** Quantas organizações têm este plano hoje. */
  readonly organizacoes: number;
  /** Uma linha a mais no cartão: "Inclui a funcionalidade Clínica". */
  readonly observacao: string | null;
};

/** O plano do contrato da API, com os nomes que a tela usa. */
export function planoDoCatalogo(plano: Plano): PlanoDoCatalogo {
  return {
    id: plano.id,
    nome: plano.nome,
    ativo: plano.ativo,
    mensalidade: plano.mensalidade,
    usuariosIncluidos: plano.usuarios_incluidos,
    armazenamentoGb: plano.armazenamento_gb,
    usuarioAdicional: plano.usuario_adicional,
    gbAdicional: plano.gb_adicional,
    organizacoes: plano.organizacoes,
    observacao: plano.observacao,
  };
}
